import script from "./ShowEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowEvent.vue?vue&type=script&setup=true&lang=js"

import "./ShowEvent.vue?vue&type=style&index=0&id=64b3138c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64b3138c"]])

export default __exports__